<profile-card class="grow" title="Mes Informations Personnelles">
  <personal-information-form></personal-information-form>
</profile-card>
